
const getMyDate = function(time){
  var oDate = new Date(time),
  oYear = oDate.getFullYear(),
  oMonth = oDate.getMonth() + 1,
  oDay = oDate.getDate(),
  oHour = oDate.getHours(),
  oMin = oDate.getMinutes(),
  oTime = '',
  amp = '上午'
  if(oHour > 12){
    amp = '下午'
  }
  oTime = oYear + '-' + getzf(oMonth) + '-' + getzf(oDay)+ ' '+ amp + ' '+getzf(oHour) + ':' + getzf(oMin)
  return oTime;
}
const getzf = function(num) {
  if (parseInt(num) < 10) {
    num = '0' + num;
  }
  return num;
}
// 判断是否为电话号码
const isTelAvailable = function(pone) {
  var myreg = /^[1][3-9][0-9]{9}$/;
  if (!myreg.test(pone)) {
    return false;
  } else {
    return true;
  }
}
export {
  getMyDate,
  isTelAvailable,
}